import { Component, OnInit } from '@angular/core';
import { TransaccionService } from '../../services/transaccion.service';
import { Transaccion } from '../../interfaces/transaccion.interface';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import * as moment from 'moment-timezone';
import { MatDialog } from '@angular/material/dialog';
import { AssignTransactionComponent } from './assign-transaction/assign-transaction.component';
import { displayedColumns } from './table-transactions-columns';
import { GetTransactionsType } from 'src/app/shared/enums/get-transactions-type';
import { CurrencyPipe } from '@angular/common';
import Swal from 'sweetalert2';
import { S3UrlService } from 'src/app/shared/services/s3-url.service';


@Component({
  selector: 'app-admin-transactions',
  templateUrl: './admin-transactions.component.html',
  styleUrls: ['./admin-transactions.component.sass'],
})
export class AdminTransactionsComponent implements OnInit {
  transacciones: Transaccion[] = [];
  seleccionados: number = 0;
  dataSource: MatTableDataSource<any> | undefined;
  subscription: Subscription = new Subscription();
  displayedColumns = displayedColumns;
  expandedCardId: number | null = null;
  private intervalId: any;
  constructor(
    private transactionService: TransaccionService,
    private dialog: MatDialog,
    private currencyPipe: CurrencyPipe,
    private s3UrlService: S3UrlService,
  ) { }
  async ngOnInit() {

    await this.loadTransactions();

    this.intervalId = setInterval(() => {
      this.loadTransactions();
    }, 60000)
  }

  async loadTransactions() {
    if(this.transacciones.length !== 0){
      const transaccion_old: Transaccion[] = this.transacciones,
      transaccion_new_result = await this.transactionService.getAllTransactions(GetTransactionsType.PENDING),
      transaccion_new: Transaccion[] = Array.isArray(transaccion_new_result) ? transaccion_new_result : (transaccion_new_result as any)?.query ?? [];
      if (!this.transaccionesIguales(transaccion_old, transaccion_new)) {
        this.transacciones = transaccion_new;
        Swal.fire({
          icon: 'info',
          title: 'Atención!',
          text: 'Las transacciones han actualizado.',
        });
      }
    }else{
      const result = await this.transactionService.getAllTransactions(GetTransactionsType.PENDING);
      this.transacciones = Array.isArray(result) ? result : (result as any)?.query ?? [];
    }
    this.dataSource = new MatTableDataSource(this.transacciones);
  }


  private transaccionesIguales(transacciones1: Transaccion[], transacciones2: Transaccion[]): boolean {
    if (transacciones1.length !== transacciones2.length) {
      return false; // Si las longitudes son diferentes, las listas no son iguales
    }
    const transacciones1Ids = transacciones1.map((t) => t.id);
    const transacciones2Ids = transacciones2.map((t) => t.id);

    // Compara los identificadores de las transacciones
    for (const id of transacciones1Ids) {
      if (!transacciones2Ids.includes(id)) {
        return false; // Si un identificador en transacciones1 no está en transacciones2, no son iguales
      }
    }
    return true; // Si todas las comparaciones fueron iguales, las listas son iguales
  }

  change() {
    this.seleccionados =
      this.dataSource?.data.filter((value) => value.seleccionado).length || 0;

  }

  limpiarSeleccion() {
    const data =
      this.dataSource?.data.map((value) => {
        return { ...value, seleccionado: false };
      }) || [];

    if (this.dataSource && this.dataSource.data) {
      this.dataSource.data = data;
    }
    this.change();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    clearInterval(this.intervalId);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (this.dataSource) {
      this.dataSource.filter = filterValue.trim().toUpperCase();
    }
  }

  public doFilter = (event: any) => {
    const element = event.currentTarget as HTMLInputElement;
    const value = element.value;
    if (this.dataSource)
      this.dataSource.filter = value.trim().toLocaleLowerCase();
  };
  //TPDP

  returnSelectedTransactions(row: Transaccion) {
    const selected =
      this.dataSource?.data?.filter((x) => x.seleccionado && x.id !== row.id) ||
      [];
    selected.push(row);
    return selected;
  }
  async openImageDialog(imageUrl: string) {
    // Post-VULN-01: backend firma la URL, el browser solo la consume.
    const signedUrl = await this.s3UrlService.getReadUrl(imageUrl);
    if (!signedUrl) {
      Swal.fire({
        icon: 'error',
        title: 'Imagen no disponible',
        text: 'No se pudo obtener el comprobante de la transacción.',
      });
      return;
    }

    const isMobile = window.innerWidth < 768;

    Swal.fire({
      title: 'Comprobante de transacción',
      html: `
        <div style="display:flex; flex-direction:column; align-items:center; gap:12px;">
          <img src="${signedUrl}" alt="Comprobante"
            style="max-width:100%; max-height:${isMobile ? '55vh' : '65vh'}; border-radius:8px; object-fit:contain; border:1px solid #e5e7eb;" />
          <a href="${signedUrl}" target="_blank" rel="noopener noreferrer"
            style="display:inline-flex; align-items:center; gap:6px; padding:8px 20px; background:#1C593D; color:white; border-radius:8px; font-size:0.85rem; font-weight:600; text-decoration:none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"/>
            </svg>
            Abrir imagen completa
          </a>
        </div>
      `,
      showCloseButton: true,
      showConfirmButton: false,
      width: isMobile ? '95vw' : '600px',
      padding: isMobile ? '12px' : '24px',
      customClass: {
        title: 'swal-voucher-title',
        popup: 'swal-voucher-popup',
      },
    });
  }

  rejectTransaction(row: Transaccion) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to reject this transaction?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reject it!',
      input: 'text',
      inputPlaceholder: 'Enter reason for rejection',
      inputValidator: (value) => {
        return value ? null : 'You need to write something!';
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        const rejectDTO = {
          transactionID: row.id,
          motivo: result.value,
        };
        try {
          await this.transactionService.rejectTransaction(rejectDTO);
          Swal.fire('Rejected!', 'The transaction has been rejected.', 'success');
          this.loadTransactions();
        } catch (error) {
          // 25/10/2026: se muestra el motivo que manda la lambda (p. ej. "La transacción
          // cambió de estado; recarga") en vez de un texto genérico.
          Swal.fire('Error!', this.mensajeDeError(error, 'There was an error rejecting the transaction.'), 'error');
          this.loadTransactions();
        }
      }
    });
  }
  /** Texto del error del backend: `error.error.mensaje` o `message`; si no hay, el genérico. */
  mensajeDeError(error: any, generico: string): string {
    const cuerpo = error?.error;
    const texto =
      (typeof cuerpo === 'object' && cuerpo !== null && (cuerpo.mensaje || cuerpo.message)) ||
      (typeof cuerpo === 'string' && cuerpo.trim());
    return typeof texto === 'string' && texto ? texto : generico;
  }

  toggleCard(id: number): void {
    this.expandedCardId = this.expandedCardId === id ? null : id;
  }

  getStatusBg(row: any): string {
    const estado = row.estado?.toUpperCase() || '';
    if (estado.includes('ENVIAD')) return '#16a34a';
    if (estado.includes('COMPLETAD')) return '#15803d';
    if (estado.includes('PAGAD')) return '#166534';
    if (estado.includes('RECHAZAD')) return '#dc2626';
    if (estado.includes('CANCELAD')) return '#991b1b';
    if (estado.includes('PROCESO') || estado.includes('PROCESAR')) return '#f59e0b';
    if (estado.includes('PENDIENTE')) return '#eab308';
    if (estado.includes('REVIS')) return '#8b5cf6';
    if (estado.includes('EXPIRAD')) return '#6b7280';
    return '#f3f4f6';
  }

  getStatusColor(row: any): string {
    const estado = row.estado?.toUpperCase() || '';
    if (estado.includes('ENVIAD')) return '#ffffff';
    if (estado.includes('COMPLETAD')) return '#ffffff';
    if (estado.includes('PAGAD')) return '#ffffff';
    if (estado.includes('RECHAZAD')) return '#ffffff';
    if (estado.includes('CANCELAD')) return '#ffffff';
    if (estado.includes('PROCESO') || estado.includes('PROCESAR')) return '#ffffff';
    if (estado.includes('PENDIENTE')) return '#ffffff';
    if (estado.includes('REVIS')) return '#ffffff';
    if (estado.includes('EXPIRAD')) return '#ffffff';
    return '#6b7280';
  }

  getDateFormatted(date: any): string {
    return date ? moment(new Date(date)).tz('America/Santiago').format('lll') : 'No aplica';
  }

  getDateOnly(date: any): string {
    return date ? moment(new Date(date)).tz('America/Santiago').format('DD/MM/YYYY') : 'No aplica';
  }

  getTimeOnly(date: any): string {
    return date ? moment(new Date(date)).tz('America/Santiago').format('HH:mm:ss') : '';
  }

  openAssignDialog(row: any) {
    const selectedTransactions = this.returnSelectedTransactions(row);
    const isMobile = window.innerWidth < 768;
    const dialogRef = this.dialog.open(AssignTransactionComponent, {
      data: {
        selectedTransactions,
      },
      maxHeight: '90vh',
      maxWidth: isMobile ? '95vw' : '826px',
      minWidth: isMobile ? '90vw' : '800px',
      width: isMobile ? '95vw' : undefined,
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result === true) {
        this.loadTransactions();
      }
      // if(result == true && this.usuarioID){
      //   this.listaCuentas = await this.accountRecipientService.getByUser(this.usuarioID);
      // }
    });
  }
}
